import ApolloClient from 'apollo-boost';
import { GraphQLError } from 'graphql';
import Honeybadger from '@honeybadger-io/js';
import fetch from 'node-fetch';
import { getIdToken } from '../utilities/api';

const isTokenExpired = (token: string) => {
  if (!token) {
    return false;
  }

  const payload = token.split('.')[1];
  const payloadDecoded = JSON.parse(atob(payload));
  return new Date().getTime() > payloadDecoded.exp * 1000;
};

let clientURI = '';

let onClientError: any = (error: any) => {
  const idToken = error.operation.getContext().headers?.idtoken;
  const hasIdToken = !!idToken && idToken !== 'null';

  error.graphQLErrors?.forEach((graphQLError: GraphQLError) => {
    const shouldLogout =
      graphQLError.message.toLowerCase() == 'unauthorized' && hasIdToken && isTokenExpired(idToken);

    if (shouldLogout) {
      window.location.href = '/logout';
    }
  });
};

const client = new ApolloClient<unknown>({
  fetch: fetch as any,
  request: async operation => {
    const headers = {
      idtoken: await getIdToken()
    };
    operation.setContext({ headers });
  },
  fetchOptions: {
    credentials: 'include'
  },
  uri: () => {
    return clientURI;
  },
  onError: props => onClientError(props)
});

export function setClientURI(uri: string): ApolloClient<unknown> {
  clientURI = uri;
  return client;
}

export function setOnError(func: Function): ApolloClient<unknown> {
  onClientError = func;
  return client;
}

export default client;
